import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

// Angular Fire
import { FirebaseApp } from "angularfire2";
import { AngularFireAuth } from "angularfire2/auth";
import { Observable } from "rxjs/Observable";
import { UsuariosPersonalService } from "../../../services/usuarios-personal.service";
import { MetricasService } from "../../../services/monitoring/metricas.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit {
    currentUser: any;

    estamosConectados: boolean = false;
    fecha: Date;
    diasSemana: string[] = [
        "Domigo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado",
    ];
    nombreUsuario: Observable<any>;
    versionBD: any;
    versionActualSistema: string = "1.6.5";
    showWrongVersion = false;
    constructor(
        private afAuth: AngularFireAuth,
        private usuariosService: UsuariosPersonalService,
        private route: Router,
        private firebaseApp: FirebaseApp,
        private metricas: MetricasService
    ) {}

    ngOnInit() {
        this.metricas.establecerVersion(this.versionActualSistema);
        this.firebaseApp
            .database()
            .ref()
            .child(".info/connected")
            .on(
                "value",
                (connected) => (this.estamosConectados = connected.val())
            );
        this.fecha = new Date(Date.now());
        this.currentUser = this.usuariosService.auth;
        if (this.currentUser)
            this.nombreUsuario = this.usuariosService
                .obtenerPropiedadDeUsuario(
                    this.currentUser.uid,
                    "informacionPersonal/nombre"
                )
                .valueChanges()
                .take(1);
        this.usuariosService
            .getUltimaVersion()
            .take(1)
            .subscribe((res) => {
                this.versionBD = res[0].num_version;
                if (this.versionBD != this.versionActualSistema) {
                    this.showWrongVersion = true;
                }
            });
    }

    // Función para cerrar sesión
    logout() {
        window.localStorage.setItem("usuario.uid", null);
        window.localStorage.setItem("departamentoRolUsuario", null);
        this.afAuth.auth.signOut();
        this.usuariosService.auth = null;
        this.route.navigateByUrl("/");
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/header/header.component.ts